import { useEffect } from 'react';

const useFocusOnError = (formik) => {
  const { errors, isSubmitting } = formik;
  useEffect(() => {
    if (isSubmitting && Object.keys(errors).length > 0) {
      const elementId = Object.keys(errors)[0];

      // try to find label first
      let element = document.querySelector(`label[for=${elementId}]`);
      // otherwise fall back to actual element
      element = element || document.getElementById(elementId);

      element?.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, [errors, isSubmitting]);
};

export default useFocusOnError;
